import { getLegacyInstanceRegistrationStatus } from './instanceRegistration';

export async function getContestPluginConfig(token) {
  const registration = await getLegacyInstanceRegistrationStatus();
  const controllerBaseUrl = String(registration?.controllerBaseUrl || '').trim().replace(/\/+$/, '');
  const instanceId = String(registration?.instanceId || '').trim();

  if (!controllerBaseUrl || !instanceId) {
    return { enabled: false, contestTypes: [] };
  }

  const response = await fetch(
    `${controllerBaseUrl}/api/plugins/contesthub/contest-types`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  if (!response.ok) {
    return { enabled: false, contestTypes: [] };
  }

  const pluginResponse = await fetch(
    `${controllerBaseUrl}/api/instances/${encodeURIComponent(instanceId)}/plugins`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  if (!pluginResponse.ok) {
    return { enabled: false, contestTypes: [] };
  }

  const pluginData = await pluginResponse.json();
  if (pluginData?.plugins?.contesthub !== true) {
    return { enabled: false, contestTypes: [] };
  }

  const data = await response.json();
  return { enabled: true, contestTypes: Array.isArray(data?.contestTypes) ? data.contestTypes : [] };
}
